import React, { Component } from 'react';
import {Button, Card, Col, DatePicker, Tag, Icon, Input, Row, Spin, Table } from 'antd';
import {CustomSpinner} from "../../Components/Spin/CustomSpiner";
import {API, Auth} from "aws-amplify";
import locale from "antd/es/date-picker/locale/es_ES";
import moment from "moment";

export default class DocumentTable extends Component {

    constructor(props) {
        super(props)
        this.state = {
            loading: true,
            documents: []
        }
    }

    componentDidMount() {
        if (this.props.candidate_id) {
            this.getDocumentsByCandidate(this.props.candidate_id)
        }else {
            Promise.all([
                Auth.currentSession(),
                Auth.currentUserInfo()
            ]).then(([response, user]) => {
                API.get(
                    'test',
                    '/cd/cddocument/',
                    {
                        headers: {
                            Authorization: response.getIdToken().getJwtToken()
                        }
                    }
                )
                .then(response => {
                    this.setState({loading: false, documents: response.documents})
                })
                .catch(err => console.log(err))
            });
        }
    }

    getDocumentsByCandidate = (candidate_id) => {
        this.setState({loading: true})
        Promise.all([
            Auth.currentSession(),
            Auth.currentUserInfo()
        ]).then(([response, user]) => {
            API.get(
                'test',
                '/cd/cddocument/'+candidate_id,
                {
                    headers: {
                        Authorization: response.getIdToken().getJwtToken()
                    }
                }
            )
            .then(response => {
                this.setState({ loading: false, documents: response.documents })
            })
            .catch(err => {
                console.log(err)
                this.setState({ loading: false })
            })
        })
    }

    getStringFilterProps = (property) => {
        return {
            filterDropdown: ({setSelectedKeys, selectedKeys, confirm, clearFilters}) => (
                <div style={{padding: 8}}>
                    <Input
                        ref={node => {
                            this.searchInput = node;
                        }}
                        placeholder="Buscar"
                        value={selectedKeys[0]}
                        onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                        onPressEnter={() => confirm()}
                        style={{width: 188, marginBottom: 8, display: 'block'}}
                    />
                    <Button
                        type="primary"
                        onClick={() => confirm()}
                        icon="search"
                        size="small"
                        style={{width: 90, marginRight: 8}}
                    >
                        Buscar
                    </Button>
                    <Button
                        onClick={() => clearFilters()}
                        size="small"
                        style={{width: 90}}
                    >
                        Reset
                    </Button>
                </div>
            ),
            filterIcon: filtered => (
                <Icon type="search" style={{color: filtered ? '#1890ff' : undefined}}/>
            ),
            onFilter: (value, record) => record[property].toString().toLowerCase().includes(value),
            onFilterDropdownVisibleChange: visible => {
                if (visible) {
                    setTimeout(() => this.searchInput.select())
                }
            }
        }
    }

    getDateFilterProps = (property) => {
        return {
            filterDropdown: ({setSelectedKeys, selectedKeys, confirm, clearFilters}) => (
                <div style={{padding: 8}}>
                    <DatePicker
                        placeholder={"Desde"}
                        value={selectedKeys[0] ? selectedKeys[0].from : null}
                        format="DD-MM-YYYY"
                        locale={locale}
                        disabledDate={d => !d || (selectedKeys[0] != null && d.isAfter(selectedKeys[0].to))}
                        onChange={e => setSelectedKeys([{from: e, to: (selectedKeys[0] ? selectedKeys[0].to : null)}])}
                        onPressEnter={() => confirm()}
                        style={{width: 188, marginBottom: 8, display: 'block'}}
                        allowClear={true}
                    />
                    <DatePicker
                        placeholder={"Hasta"}
                        disabledDate={d => !d || (selectedKeys[0] != null && d.isBefore(selectedKeys[0].from))}
                        value={selectedKeys[0] ? selectedKeys[0].to : null}
                        format="DD-MM-YYYY"
                        locale={locale}
                        onChange={e => setSelectedKeys([{
                            to: e,
                            from: (selectedKeys[0] ? selectedKeys[0].from : null)
                        }])}
                        onPressEnter={() => confirm()}
                        style={{width: 188, marginBottom: 8, display: 'block'}}
                        allowClear={true}
                    />
                    <Button
                        type="primary"
                        onClick={() => confirm()}
                        icon="search"
                        size="small"
                        style={{width: 90, marginRight: 8}}
                    >
                        Buscar
                    </Button>
                    <Button
                        onClick={() => clearFilters()}
                        size="small"
                        style={{width: 90}}
                    >
                        Reset
                    </Button>
                </div>
            ),
            filterIcon: filtered => (
                <Icon type="search" style={{color: filtered ? '#1890ff' : undefined}}/>
            ),
            onFilter: (value, record) => {
                const date = moment(record[property], 'YYYY-MM-DD');
                return date.isValid() && date.isAfter(value.from) && date.isBefore(value.to) || date.isSame(value.to) || date.isSame(value.from);
            }
        }
    }

    columns = [
        {
            title: 'Candidato Nro Doc.',
            key: 'candidateNumberDoc',
            dataIndex: 'candidateNumberDoc',
            ...this.getStringFilterProps('candidateNumberDoc')
        },
        {
            title: 'Tipo Documento',
            key: 'typeDocumentName',
            dataIndex: 'typeDocumentName',
            ...this.getStringFilterProps('typeDocumentName')
        },
        {
            title: 'Fecha Creación',
            key: 'created',
            dataIndex: 'documentId',
            render: (value, row, index) => {
                return {
                    children: value ? moment.unix(value).format("YYYY-MM-DD") : ''
                }
            },
            /*sorter: (a, b) => (a.created && b.created) ? moment(a.created, 'YYYY-MM-DD').diff(moment(b.created, 'YYYY-MM-DD'), 'days') : 1,
            defaultSortOrder: 'descend'*/
        },
        {
            title: 'Estado',
            key: 'stateDocument',
            dataIndex: 'stateDocument',
            render: (value) => {
                let color = ""
                let text = ""
                switch (value) {
                    case "RECEIVED":
                        color = ""
                        text = "Recibido"
                        break
                    case "CLASSIFIED":
                        color = "orange"
                        text = "Clasificado"
                        break
                    case "CLASSIFICATION_ERROR":
                        color = "grey"
                        text = "Sin Clasificar"
                        break
                    case "EXTRACTED":
                        color = "gray"
                        text = "Extraído"
                        break
                    case "MANUAL_REVIEW":
                        color = "#5499C7"
                        text = "Revisión Manual"
                        break
                    case "VALIDATED":
                        color = "green"
                        text = "Validado"
                        break
                    case "NOT_VALIDATED":
                        color = "volcano"
                        text = "No Validado"
                        break
                    case "APPROVED":
                        color = "blue"
                        text = "Aprobado"
                        break
                    case "NOT_APPROVED":
                        color = "red"
                        text = "Desaprobado"
                        break
                }
                return {
                    children:
                        <Tag color={color}>
                            {text}
                        </Tag>
                }
            },
            filters: [
                {
                    text: "Recibido",
                    value: "RECEIVED"
                },
                {
                    text: "Clasificado",
                    value: "CLASSIFIED"
                },
                {
                    text: "Sin Clasificar",
                    value: "CLASSIFICATION_ERROR"
                },
                {
                    text: "Extraído",
                    value: "EXTRACTED"
                },
                {
                    text: "Revisión Manual",
                    value: "MANUAL_REVIEW"
                },
                {
                    text: "Validado",
                    value: "VALIDATED"
                },
                {
                    text: "No Validado",
                    value: "NOT_VALIDATED"
                },
                {
                    text: "Aprobado",
                    value: "APPROVED"
                },
                {
                    text: "Desaprobado",
                    value: "NOT_APPROVED"
                }
            ],
            filterMultiple: true,
            onFilter: (value, record) => record.stateDocument.indexOf(value) === 0
        },
        {
            title: 'Acciones',
            dataIndex: 'actions',
            key: 'actions',
            render: (text, record, index) => {
                return {
                    children: <>
                        <Button onClick={(e) => this.editDocument(e, record) } icon="search">
                        </Button>
                    </>
                }
            }
        }
    ]

    editDocument(e, record) {
        this.props.editDocument(record)
    }

    render() {
        if (this.state.loading) {
            return (
                <>
                    <Row type="flex" justify="space-around" align="middle" style={{marginTop: '150px'}}>
                        <Col style={{minHeight: '360px'}}>
                            <Spin indicator={CustomSpinner}/>
                        </Col>
                    </Row>
                </>
            )
        } else {
            return (
                <Row>
                    <Card title={'Documentos'}>
                        <Table
                            columns={this.columns}
                            dataSource={this.state.documents}
                            scroll={{x: "max-content"}}
                            style={{margin: "20px"}}
                            loading={this.state.loading}
                            pagination={{
                                showSizeChanger: true,
                                pageSizeOptions: ['20', '35', '50'],
                                defaultPageSize: 20,
                                hideOnSinglePage: true
                            }}
                        />
                    </Card>
                </Row>
            )
        }
    }
}
